<template>
    <span class='alert-button-position'>
        <CustomButton name="addAlert"
                      :click="() => addAlert()"
                      :tooltip="__('Add alert')"
                      style="margin:0 5px"
                      severity="info">
            <i class="fa-solid fa-bell alert-icon"> </i>
        </CustomButton>
    </span>
</template>

<script setup>
import { ref } from 'vue'
import CustomButton from '@crud/CustomButton.vue'
import { __ } from '@helper/utils.js'

const props = defineProps({
    addAlert: Function,
})
</script>

<style lang="scss" scoped></style>
